import React, { Component } from "react";
import {
  Box,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Heading,
  Text,
  TableCell
} from "grommet";
import LogbookTableRows from "./LogbookTableRows";

export class LogbookContainer extends Component {
  componentDidMount = () => {
    this.updateRowData();
  };

  updateRowData = () => {
    console.log("logbooktable props", this.props);
  };

  getPrettyDateString = dateString => {
    const firstArray = dateString.split("T");
    const timeString = firstArray[1];
    const secondArray = timeString.split("+");
    return secondArray[0];
  };

  getTimeDifference = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const difference = new Date(end - start);

    let differenceString = difference.toISOString().substr(11, 8);
    const diffArray = differenceString.split(":");
    if (diffArray[0] === "00") {
      differenceString = diffArray[1] + ":" + diffArray[2];
    }
    return differenceString;
  };
  render() {
    const logbook = this.props.logbook;
    let timeStartBlock;
    let timeEndBlock;
    if (logbook.logbookTimeType === "Sign-in/Sign-out") {
      timeStartBlock = (
        <TableCell>
          <Text>Time Start/In</Text>
        </TableCell>
      );
      timeEndBlock = (
        <TableCell>
          <Text>Time End/Out</Text>
        </TableCell>
      );
    } else {
      timeStartBlock = (
        <TableCell>
          <Text>Time</Text>
        </TableCell>
      );
    }

    return (
      <Box>
        <Table>
          <TableHeader>
            <TableCell>
              <Text>Guard</Text>
            </TableCell>
            {logbook.LogbookItems.map(logbookItem => {
              return (
                <TableCell>
                  <Text>{logbookItem.title}</Text>
                </TableCell>
              );
            })}
            {timeStartBlock}
            {timeEndBlock}
          </TableHeader>
          <TableBody>
            <LogbookTableRows
              logbook={logbook}
              firebase={this.props.firebase}
            ></LogbookTableRows>
          </TableBody>
        </Table>
      </Box>
    );
  }
}

export default LogbookContainer;
